import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClickedPublicBoardLink } from "@air/analytics";
import { DoubleChevronLeft } from "@air/next-icons";
import Router from "next/router";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { AirLogoLink } from "~/components/AssetModalV2/Header/components/AirLogoLink";
import { PublicTopBarAccountInfo } from "~/components/Layouts/PublicBoardLayout/PublicTopBarAccountInfo";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { createAllContentAssetRoute } from "~/constants/routes";
import { useAccountContext } from "~/providers/AccountProvider";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
export const LoggedInBanner = /*#__PURE__*/ memo(()=>{
    const { workspaceName } = usePublicWorkspace();
    const clipId = useSelector(centralizedClipIdSelector);
    const { trackClickedPublicBoardLink } = useTrackClickedPublicBoardLink();
    const { data: account } = useAccountContext();
    const onClick = useCallback(()=>{
        trackClickedPublicBoardLink({
            name: "clicked view in workspace",
            page_area: "banner",
            page_type: "public asset"
        });
        Router.push(createAllContentAssetRoute(clipId));
    }, [
        clipId,
        trackClickedPublicBoardLink
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex size-full items-center justify-between bg-pigeon-900 px-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex cursor-pointer items-center justify-start text-grey-10 hover:text-grey-12",
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx(DoubleChevronLeft, {
                        className: "mr-1 size-5 text-inherit"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "truncate text-16 font-medium text-inherit",
                        children: [
                            "View in ",
                            workspaceName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-4",
                children: [
                    !!account && /*#__PURE__*/ _jsx(PublicTopBarAccountInfo, {
                        account: account
                    }),
                    /*#__PURE__*/ _jsx(AirLogoLink, {})
                ]
            })
        ]
    });
});
LoggedInBanner.displayName = "LoggedInBanner";
